import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Select,
  Radio,
  DatePicker,
  Space,
  Checkbox,
  Row,
  Col,
  Button,
  Card,
  Modal,
  Skeleton,
  Dropdown,
  Menu,
} from "antd";
// import 'antd/dist/antd.css';
// import './tailwind.output.css'; // Ensure Tailwind CSS is correctly imported
import Express from "../../../../assets/img/orders/Express.png";
import Noraml from "../../../../assets/img/orders/Normal.png";
import vip from "../../../../assets/img/orders/vip.png";
import privates from "../../../../assets/img/orders/private.png";

import Wash from "../../../../assets/img/orders/Wash.png";
import DryClean from "../../../../assets/img/orders/DryClean.png";
import WashIron from "../../../../assets/img/orders/WashIron.png";
import tick from "../../../../assets/img/orders/tick.png";
import sort from "../../../../assets/img/orders/sort.png";

import iron from "../../../../assets/img/orders/iron.png";
import Thobe from "../../../../assets/img/orders/Thobe.png";
import LocationIcon from "../../../../assets/img/orders/locationIcon.png";
import EditIcon from "../../../../assets/img/orders/Edit.png";
import Search from "../../../../assets/img/orders/search.png";

import minusIcon from "../../../../assets/img/orders/minusIcon.png";
import plusIcon from "../../../../assets/img/orders/plusIcon.png";
import editCollection from "../../../../assets/img/orders/editcollection.png";
import collectionDate from "../../../../assets/img/orders/collectionDate.png";
import deliverytime from "../../../../assets/img/orders/deliverytime.png";
import editdeleivery from "../../../../assets/img/orders/editdeleivery.png";
import { Field, useFormik } from "formik";
import OrderCard from "components/card/OrderCard";
import CreateOrderUser from "../OrderUser/CreateOrderUser";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_LIST_ITEM } from "api/item-management";
import { CONSTANTS } from "config/constant";
// import CalendarSlot from "components/fields/CalendarSlot";
import PaymentModal from "components/card/PaymentModal";
import { useUser } from "config/selectedUserContext";
import {
  CloseOutlined,
  DownOutlined,
  UserOutlined,
  HomeOutlined,
  SettingOutlined,
  SmileOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { UseUser } from "config/selectedUserContext";
import { UseItemList } from "config/itemListContext";
import DetailModalCards from "components/Modal/DetailModalCards";
import { API_LIST_ITEM_SERVICE } from "api/item-services-managemnt";
import { UseItemNotes } from "config/Notes";
import { MenuProps } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;
const { RangePicker } = DatePicker;

const AddOrder = () => {
  const { alItemsList, setAllitemsList } = UseItemList();

  const [activeCard, setActiveCard] = useState(null); // State to track active card
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [slotVisible, setSlotVisible] = useState(false);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [coupenVisible, setCoupenVisible] = useState(false);
  const [dataItemService, setDataItemService] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedCatagoryIndex, setSelectedCatagoryIndex] = useState(null);
  const [privateCleaning, setPrivateCleaning] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("");
  const [catagoryLoading, setCatagoryLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState("");
  // const [itemNotes, setItemNotes] = useState({});
  const [clickedItem, setClickedItem] = useState(null);

  const [selectedServiceId, setSelectedServiceId] = useState(
    "66213993fda555a0f8d1f8bf"
  );

  const [selectedItem, setSelectedItem] = useState(null);

  const [filteredItemsUpdated, setFilteredItemsUpdated] = useState([]);
  // const [itemsList, setItemsList] = useState([]);

  const [itemCounts, setItemCounts] = useState({});

  const [modalVisibleUser, setModalVisibleUser] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [selectedCatagory, setSelectedCatagory] = useState("");

  const [itemOptions, setItemOptions] = useState([]);

  const [paginationCatagories, setPaginationCatagories] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const { selectUser, selectedUser } = UseUser();
  const [searchedKeyWord, setSearchedKeyWord] = useState("");
  const { updateNote, itemNotes } = UseItemNotes();
const {t}=useTranslation();
  const handleOrderTypeClick = (orderType) => {
    setSelectedOrderType(orderType);
  };

  const [paginationItems, setPaginationItems] = useState({
    current: 1,
    pageSize: 100, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });

  const timeSlots = [
    "06:00 - 08:00 AM",
    "08:00 - 10:00 AM",
    "10:00 - 12:00 PM",
  ];
  const handleItemClick = (index, serviceId) => {
    setSelectedIndex(index);
    setSelectedServiceId(serviceId);
  };
  const handleCatagoryClick = (index, cat) => {
    setSelectedCatagoryIndex(index);
    setSearchName(cat?._id);
    setSelectedCatagory(cat);
    console.log("cat", cat);
    // setSelectedServiceId(serviceId);
  };

  // const updateNote = (itemId, note) => {
  //   console.log("itemId", itemId);
  //   setItemNotes((prevNotes) => ({
  //     ...prevNotes,
  //     [itemId]: note,
  //   }));

  //   // Update the note in the allItemsList for items with the same itemId
  //   setAllitemsList((prevSelectedItems) =>
  //     prevSelectedItems.map((item) =>
  //       item._id === itemId ? { ...item, note } : item
  //     )
  //   );
  // };

  const filteredItems = itemOptions?.items?.filter((item) =>
    item.item_service?.some(
      (service) => service.item_service === selectedServiceId
    )
  );

  const handleCardClick = (item) => {
    setIsModalVisible(true);
    setSelectedItem(item);
    setClickedItem(item);
    setItemCounts((prevItemCounts) => {
      const updatedCounts = { ...prevItemCounts };
      item.item_service.forEach((service) => {
        const itemId = service._id;
        updatedCounts[itemId] = updatedCounts[itemId] || 0;
      });
      return updatedCounts;
    });

    // // Optionally update allitemsList if needed
    // setAllitemsList((prevSelectedItems) => {
    //   if (prevSelectedItems.some((selected) => selected._id === item._id)) {
    //     return prevSelectedItems;
    //   }
    //   return [...prevSelectedItems, item];
    // });
  };

  // const handleCardClick = (item) => {
  //   console.log("item click", item);
  //   // if already in all itme list then chosse item
  //   setSelectedItem(alItemsList?.find((l) => l?._id === item?._id) ?? item);
  //   setIsModalVisible(true);

  //   setAllitemsList((prevSelectedItems) => {
  //     if (prevSelectedItems.some((itemsList) => itemsList?._id === item._id)) {
  //       return prevSelectedItems;
  //     }
  //     // Add the new item to the array
  //     return [...prevSelectedItems, item];
  //   });
  //   setItemCounts((prevItemCounts) => ({
  //     ...prevItemCounts,
  //     [item._id]: prevItemCounts?.[item._id] ?? 1,
  //   }));
  //   setItemCounts((prevItemCounts) => ({
  //     ...prevItemCounts,
  //     [item._id]: prevItemCounts?.[item._id] ?? 1,
  //   }));
  // };
  
  const handleRemoveClick = (item) => {
    setAllitemsList((prevSelectedItems) =>
      prevSelectedItems.filter((selectedItem) => selectedItem?._id !== item._id)
    );

    setItemCounts((prevItemCounts) => {
      const newItemCounts = { ...prevItemCounts };
      delete newItemCounts[item._id];
      return newItemCounts;
    });
  };

  const handleModalClose = () => {
    if (selectedItem) {
      // Update notes for the selected item
      updateNote(selectedItem._id, itemNotes[selectedItem._id] ?? "");

      console.log("sasas", selectedItem._id, itemNotes[selectedItem._id]);
    }

    setIsModalVisible(false);
    setSelectedItem(null);
  };

  const handleCountMinus = (itemId) => {
    console.log("handleCountMinus", itemId);
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [itemId]: Math.max((prevCounts[itemId] || 1) - 1, 0), // Ensure count doesn't go below 0
    }));
  };

  const handleCountPlus = (itemId) => {
    console.log("handleCountPlus itemId:", itemId); // Ensure itemId is correctly logged
    setItemCounts((prevCounts) => ({
      ...prevCounts,
      [itemId]: (prevCounts[itemId] || 0) + 1,
    }));
  };

  // const handleCountPlus = (item) => {
  //   setItemCounts((prevItemCounts) => ({
  //     ...prevItemCounts,
  //     [item._id]: (prevItemCounts[item._id] || 1) + 1,
  //   }));
  // };

  // const handleCountMinus = (item) => {
  //   setItemCounts((prevItemCounts) => {
  //     const newCount = (prevItemCounts[item._id] || 1) - 1;
  //     if (newCount < 1) return prevItemCounts; // Prevent count from going below 1
  //     return {
  //       ...prevItemCounts,
  //       [item._id]: newCount,
  //     };
  //   });
  // };

  const fetchDataCatagories = async () => {
    setCatagoryLoading(true);

    try {
      // setLoading(true);
      const params = {
        page: paginationCatagories.current,
        limit: paginationCatagories.pageSize,
        // limit: 50,
        // name: searchName,
      };
      const newData = await API_LIST_CATAGORY(params);
      console.log("provider", newData);
      setCategoryOptions(newData);
      setCatagoryLoading(false);
      setPaginationCatagories({
        ...paginationCatagories,
        total: newData.total_categories,
      }); // Assuming API response contains total count
      const firstCategory = newData?.categories?.[0];
      if (firstCategory) {
        setSearchName(firstCategory?._id);
        setSelectedCatagory(firstCategory);
      } else {
        // Handle case where there are no categories
        setSearchName(null);
        setSelectedCatagory(null);
      }
      // setSearchName(newData?.categories?.[0]?._id);
      // setSelectedCatagory(newData?.categories?.[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
      setCatagoryLoading(false);
    }
  };
  const fetchDataItems = async () => {
    setItemLoading(true);
    try {
      const params = {
        page: paginationItems.current,
        limit: 100,
        category: searchName,
        name: searchedKeyWord,
        service: selectedServiceId,
      };
      const newData = await API_LIST_ITEM(params);
      console.log("provider", newData);
      setItemOptions(newData);
      setItemLoading(false);
      setPaginationItems({ ...pagination, total: newData.total_items }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setItemLoading(false);
    }
  };
  // const calculateTotalPrice = (item) => {
  //   console.log("item cal", item);
  //   const total = item?.item_service?.reduce(
  //     (total, service) => total + Number(service?.price),
  //     0
  //   );
  //   const itemCount = itemCounts[item._id] || 1;
  //   return total * itemCount;
  // };

  // working one
  // const calculateTotalPrice = (item) => {
  //   let totalPrice = 0;

  //   const itemCount = itemCounts[item._id] || 1;

  //   item?.item_service?.forEach((service) => {
  //     const servicePrice = Number(service?.price);
  //     const serviceItemCount = itemCounts[service?._id] || 1; // Get count for this service ID

  //     totalPrice += servicePrice * serviceItemCount;
  //   });

  //   // Multiply totalPrice by itemCount (count of this item)
  //   totalPrice *= itemCount;

  //   return totalPrice;
  // };

  const calculateTotalPrice = (item) => {
    return item?.item_info
      ? item?.item_info?.item_service.reduce((total, service) => {
          const quantity =
            itemCounts[service._id] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0)
      : item?.item_service.reduce((total, service) => {
          const quantity =
            itemCounts[service._id] || Number(service.quantity) || 0;
          const price = service.price ? parseFloat(service.price) : 0;
          return total + quantity * price;
        }, 0);
  };

  // const calculateTotalPricedItems = (item) => {
  //   console.log("item cal", item);
  //   return item?.item_service?.reduce(
  //     (total, service) => total + Number(service?.price),
  //     0
  //   );
  // }
  const calculateTotalPricedItems = (item) => {
    console.log("item cal", item);
    console.log("selectedServiceId", selectedServiceId);
    return item?.item_service
      ?.filter((service) => service?.item_service === selectedServiceId)
      ?.reduce((total, service) => total + Number(service?.price), 0);
  };

  // const calculateTotalPrice = (item) => {
  //   console.log("item cal", item);

  //   // Initialize total price
  //   let totalPrice = 0;

  //   // Iterate over each service in item_service
  //   item?.item_service?.forEach((service) => {
  //     const serviceId = service?._id;
  //     const servicePrice = Number(service?.price);
  //     const itemCount = itemCounts[serviceId] || 1; // Get count for this service ID

  //     // Calculate total price for this service and add to totalPrice
  //     totalPrice += servicePrice * itemCount;
  //   });

  //   return totalPrice;
  // };

  const fetchDataItemServices = async () => {
    setServiceLoading(true);
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_ITEM_SERVICE(params);
      console.log("item service", newData);
      setDataItemService(newData?.item_services);
      setServiceLoading(false);

      // setPagination({ ...pagination, total: newData.total_item_services }); // Assuming API response contains total count
    } catch (error) {
      setServiceLoading(false);

      console.error("Error fetching data:", error);
    }
  };
  const imageUrls = [
    Wash,
    DryClean,
    WashIron,
    iron,
    // Add more image paths as needed
  ];

  const resetAllStates = () => {
    setAllitemsList([]);
    selectUser("");
    // setTotalPrice(null);
    // setItemCounts(null);
    // Reset other state variables here
  };

  // useEffect to handle selectItemList update based on itemCounts
  useEffect(() => {
    if (clickedItem) {
      // Check if any item_service count is more than 0
      const hasValidCount = clickedItem.item_service.some(
        (service) => itemCounts[service._id] && itemCounts[service._id] > 0
      );
      // Only update selectItemList if there is a valid count
      if (hasValidCount) {
        setAllitemsList((prevSelectedItems) => {
          if (
            prevSelectedItems.some(
              (selected) => selected._id === clickedItem._id
            )
          ) {
            return prevSelectedItems;
          }
          return [...prevSelectedItems, clickedItem];
        });
      } else {
        // Remove the item from allItemsList if count is 0
        setAllitemsList((prevSelectedItems) =>
          prevSelectedItems.filter(
            (selected) => selected._id !== clickedItem._id
          )
        );
      }
    }
  }, [itemCounts, clickedItem]);

  useEffect(() => {
    fetchDataItemServices();
  }, []);

  useEffect(() => {
    fetchDataCatagories();
  }, [paginationCatagories.current, paginationCatagories.pageSize]);

  useEffect(() => {
    if (searchName) {
      fetchDataItems();
    }
  }, [
    // paginationItems.current,
    // paginationItems.pageSize,
    searchName,
    searchedKeyWord,
    selectedServiceId,
  ]);

  useEffect(() => {
    if (selectedUser) {
      setModalVisibleUser(false);
    }
  }, [selectedUser]);

  useEffect(() => {
    let itemsCount = 0;
    const total = alItemsList?.reduce((total, item) => {
      const itemTotal = calculateTotalPrice(item);
      itemsCount += itemCounts[item._id] || 1;
      return total + itemTotal;
    }, 0);
    setTotalPrice(total);
  }, [alItemsList, itemCounts]);

  useEffect(() => {
    setSelectedOrderType("normal");
    setSelectedIndex(0);
    setSelectedCatagoryIndex(0);
    resetAllStates();
  }, []);
  const formik = useFormik({
    initialValues: {
      customerType: [],
      firstName: "",
      lastName: "",
      phoneNumber: "",
      address: "",
      apartment: "",
      floor: "",
      street: "",
      traditionalItem: "",
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });
  const [checkedItems, setCheckedItems] = useState([]);
  const handleMenuClick = ({ key }) => {
    setCheckedItems((prevCheckedItems) =>
      prevCheckedItems.includes(key)
        ? prevCheckedItems.filter((item) => item !== key)
        : [...prevCheckedItems, key]
    );
  };

  const childRef = useRef(null);
  const handleReset = () => {
    if (childRef.current) {
      childRef.current.resetForm();
    }
  };

  const menuItems = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="All">
        <Checkbox checked={checkedItems.includes("All")}>All</Checkbox>
      </Menu.Item>
      <Menu.Item key="Show A to Z">
        <Checkbox checked={checkedItems.includes("Show A to Z")}>
          Show A to Z
        </Checkbox>
      </Menu.Item>
      <Menu.Item key="Low to High Price">
        <Checkbox checked={checkedItems.includes("filter3")}>
          Low to High Price
        </Checkbox>
      </Menu.Item>
      <Menu.Item key="High to Low Price">
        <Checkbox checked={checkedItems.includes("High to Low Price")}>
          High to Low Price
        </Checkbox>
      </Menu.Item>
    </Menu>
  );
  console.log("selectedCatagory", selectedCatagory);
  return (
    <>
      <div>
        <Row className="mb-4" gutter={[16, 16]}>
          <Col span={6}>
            <div
              className={`relative flex cursor-pointer  items-center rounded-[11.12px] bg-white  p-4 pb-2 pt-2 text-center shadow ${
                selectedOrderType === "normal"
                  ? "custom-border  text-[#3860A4] "
                  : "bg-white "
              }`}
              onClick={() => handleOrderTypeClick("normal")}
            >
              <img
                src={Noraml}
                alt="Normal Cleaning"
                className=" mb-2 h-[3.3rem] "
              />
              <span
                className={`font-poppins text-[28px]  font-medium ${
                  selectedOrderType === "Normal"
                    ? " text-[#3860A4]"
                    : "text-[#8B8B8B]"
                } `}
              >
                {t("Normal Cleaning")}
              </span>
              {selectedOrderType === "normal" && (
                <img src={tick} className="absolute right-[5px] top-[5px] " />
              )}
            </div>
          </Col>
          <Col span={6}>
            <div
              className={`relative flex cursor-pointer  items-center rounded-[11.12px] bg-white p-4 pb-2 pt-2 text-center shadow ${
                selectedOrderType === "express"
                  ? "custom-border  text-[#3860A4] "
                  : "bg-white "
              }`}
              onClick={() => handleOrderTypeClick("express")}
            >
              <img
                src={Express}
                alt="Express Cleaning"
                className=" mb-2 h-[3.3rem] pl-[23px] pr-[23px]"
              />
              <span
                className={`font-poppins text-[28px]  font-medium ${
                  selectedOrderType === "Express"
                    ? " text-[#3860A4]"
                    : "text-[#8B8B8B]"
                } `}
              >
                {t("Express Cleaning")}
              </span>
              {selectedOrderType === "express" && (
                <img src={tick} className="absolute right-[5px] top-[5px] " />
              )}
            </div>
          </Col>
          <Col span={6}>
            <div>
              <div
                className={`relative flex cursor-pointer  items-center rounded-[11.12px] bg-white p-4 pb-2 pt-2 text-center shadow  ${
                  selectedOrderType === "Private"
                    ? "custom-border  text-[#3860A4]"
                    : "bg-white"
                }`}
                onClick={() => handleOrderTypeClick("Private")}
              >
                <img
                  src={privates}
                  alt="Express Cleaning"
                  className=" mb-2 h-[3.3rem] pl-[23px] pr-[23px]"
                />
                <span
                  className={`font-poppins text-[28px] font-medium ${
                    selectedOrderType === "Private"
                      ? " text-[#3860A4]"
                      : "text-[#8B8B8B]"
                  }`}
                >
                  {t("Private Cleaning")}
                </span>
                {selectedOrderType === "Private" && (
                  <img
                    src={tick}
                    className="absolute right-[5px] top-[5px]"
                    alt=""
                  />
                )}
              </div>
            </div>
          </Col>
          <Col span={6}>
            <div
              className={`relative flex cursor-pointer   items-center rounded-[11.12px] bg-white p-4 pb-2 pt-2 text-center shadow  ${
                selectedOrderType === "VIP"
                  ? "custom-border  text-[#3860A4] "
                  : "bg-white "
              }`}
              onClick={() => handleOrderTypeClick("VIP")}
            >
              <img
                src={vip}
                alt={t("VIP Cleaning")}
                className=" mb-2 h-[3.3rem] pl-[23px] pr-[23px]"
              />
              <span
                className={`font-poppins text-[28px]  font-medium ${
                  selectedOrderType === "VIP"
                    ? " text-[#3860A4]"
                    : "text-[#8B8B8B]"
                } `}
              >
                {t("VIP Cleaning")}
              </span>
              {selectedOrderType === "VIP" && (
                <img src={tick} className="absolute right-[5px] top-[5px] " />
              )}
            </div>
          </Col>
        </Row>
      </div>
      <Row className="pl-2" gutter={[16, 16]}>
        <Col span={15}>
          <div className="h-[100%]  rounded-[17px] bg-white pl-9 pr-9 shadow-md">
            {serviceLoading ? (
              <div className="mt-2">
                <Skeleton active />
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <p className="min-h-12 pl-[8px] font-[inter] font-medium text-[#000000]"></p>
                {t("Select Service :")}
                {dataItemService?.map((service, index) => {
                  const isActive = index === selectedIndex;

                  return (
                    <div
                      key={index}
                      onClick={() => handleItemClick(index, service?._id)}
                      className={`ga-2 border-left flex cursor-pointer items-center rounded border-[0.5px] p-2 font-poppins text-[12px] font-medium ${
                        selectedIndex === index
                          ? "bg-[#E6E6E6] text-[#3860A4]"
                          : "bg-white text-[#8B8B8B]"
                      }`}
                    >
                      <img
                        src={imageUrls[index]}
                        alt={`Service ${index + 1}`}
                        className="h-11 w-11"
                      />
                      <p>{service?.name}</p>
                    </div>
                  );
                })}
              </div>
            )}
            <hr className="mb-3" />
            {catagoryLoading ? (
              <Skeleton active />
            ) : (
              <div className="relative">
                <div
                  className={`scroll-behaviour mb-4 mt-8 flex space-x-2 ${
                    categoryOptions?.categories?.length > 11
                      ? "overflow-scroll"
                      : ""
                  } overflow-y-hidden pb-2 pl-4 `}
                >
                  {categoryOptions?.categories?.map((catagory, index) => {
                    const isActive = searchName?._id === catagory?._id;

                    return (
                      <div
                        className={`w-full cursor-pointer rounded border-[0.5px] p-2 text-center font-poppins text-[12px] font-medium ${
                          selectedCatagoryIndex === index
                            ? "bg-[#E8E5FF] text-[#3860A4]"
                            : "bg-white text-[#8B8B8B]"
                        }`}
                        key={catagory?._id}
                      >
                        <p
                          className="w-full whitespace-nowrap"
                          onClick={() => handleCatagoryClick(index, catagory)}
                        >
                          {catagory?.title}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div
                  className="absolute -right-7 top-0 h-[50px] w-[30px] cursor-pointer bg-white"
                  onClick={() => {
                    setPaginationCatagories({
                      ...paginationCatagories,
                      pageSize: paginationCatagories.pageSize + 10,
                    });
                  }}
                >
                  <RightOutlined />
                </div>
              </div>
            )}
            <hr />
            <div>
              <h2 className="pl-4 text-lg font-medium">{searchName?.title}</h2>
              <div className="mt-[10px] flex flex-row items-center justify-between">
                <div className="text-[15.3px] font-semibold leading-[18.52px] ">
                  {selectedCatagory?.title}
                </div>
                <div className="flex flex-row items-center gap-[12px]">
                  <div className="relative h-[35px] rounded-[6px] border-[1px] border-gray-400">
                    <input
                      type="search by name"
                      placeholder={t("Search")}
                      className="h-full w-full rounded-[10px] px-[5px] text-gray-400 outline-none  "
                      value={searchedKeyWord}
                      onChange={(e) => setSearchedKeyWord(e.target.value)}
                    />
                    <img
                      src={Search}
                      alt=""
                      className="absolute right-[10px]  top-[10px] h-[13px] w-[13px]"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-3 pl-4">
                <Row gutter={[16, 16]}>
                  {itemLoading ? (
                    <Skeleton active />
                  ) : (
                    itemOptions?.items?.map((item, index) => {
                      const totalPrice = calculateTotalPricedItems(item);

                      return (
                        <Col span={6} key={index}>
                          <Card
                            className="side-card cursor-pointer rounded-lg border shadow-lg"
                            key={index}
                            onClick={() => handleCardClick(item)}
                          >
                            <div className="flex items-center justify-between pr-2">
                              <div className="p-1">
                                <img
                                  src={
                                    CONSTANTS?.IMG_DIRECTORY +
                                    item?.images?.[0]?.file_url
                                  }
                                  alt="Item"
                                  className="h-12 w-12 rounded-2xl"
                                />
                              </div>
                              <div>
                                <h3 className=" font-poppins text-[15px] font-normal text-[#3860A4]">
                                  {item?.name}
                                </h3>
                              </div>
                              <div>
                                <span className="font-poppins font-semibold text-[#3860A4]">
                                  {t("SAR")} {totalPrice}
                                </span>
                              </div>
                            </div>
                          </Card>
                        </Col>
                      );
                    })
                  )}
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span={9}>
          <div className="rounded-[17px] bg-white  p-8 pl-[21px] shadow-md">
            <OrderCard
              itemCounts={itemCounts}
              setItemCounts={setItemCounts}
              totalPrice={totalPrice}
              setTotalPrice={setTotalPrice}
              catagory={searchName}
              selectedOrderType={selectedOrderType}
              setSelectedOrderType={setSelectedOrderType}
            />
          </div>
        </Col>
      </Row>
      {/* const closeDeliveryModal = () => {
    console.log('wow','iamdata',slotVisible,pickUpTime,selectedOrderType)
    
    setSlotVisibleDelvery(false);
    setPickUpTime(null);
    setSelectedOrderType(null);
  } */}
      <Modal
        visible={selectedOrderType === "Private" || selectedOrderType === "VIP"}
        centered
        closable={true}
        onCancel={() => handleOrderTypeClick("Ok")}
      >
        <div className="flex items-center justify-center text-center text-[25px] text-[#3860A4]">
          {" "}
          <p>{t("Comming Soon")}</p>{" "}
        </div>
      </Modal>
      <Modal visible={isModalVisible} onCancel={handleModalClose}>
        <DetailModalCards
          itemCounts={itemCounts}
          handleCountMinus={handleCountMinus}
          handleCountPlus={handleCountPlus}
          selectedItem={selectedItem}
          totalPrice={totalPrice}
          setTotalPrice={setTotalPrice}
          catagory={searchName}
          itemNotes={itemNotes}
          updateNote={updateNote}
        />
      </Modal>
      <Modal
        visible={modalVisibleUser}
        onCancel={() => {
          setModalVisibleUser(false);
          handleReset();
        }}
        style={{ minWidth: "67rem" }}
        className="order-modal"
      >
        <div className="mb-6">
          <CreateOrderUser
            onSuccessModal={() => {
              setModalVisibleUser(false);
            }}
            ref={childRef}
          />
        </div>
      </Modal>

      {/* <Modal
        visible={slotVisible}
        onCancel={() => setSlotVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <CalendarSlot />
        </div>
      </Modal> */}
      {/* 
      <Modal
        visible={paymentVisible}
        onCancel={() => setPaymentVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <PaymentModal />
        </div>
      </Modal> */}

      {/* <Modal
        visible={coupenVisible}
        onCancel={() => setCoupenVisible(false)}
        style={{ minWidth: "35rem" }}
        className="order-modal-payment"
      >
        <div className="mb-6">
          <div className=" rounded-lg bg-white p-4 shadow-md">
            <h2 className="mb-4 font-poppins text-xl font-semibold text-[#3860A4]">
              Add Coupen
            </h2>
            <hr className="text-[#C5C5C5]" />

            <div className="mb-4">
              <p className="mb-4 mt-4 font-poppins font-normal text-[#9496AE]">
                Enter your coupon code during checkout to enjoy the discount, if
                you have received any.
              </p>
              <div className="relative">
                <label
                  for="floating_outlined"
                  className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                >
                  Add Coupen Code
                </label>
                <div className="flex items-center gap-1">
                  <input className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500" />

                  <Button className="btn-gradient  ml-auto flex w-40 items-center justify-center p-5 py-6 text-[white]">
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal> */}
    </>
  );
};

export default AddOrder;
